import React from 'react';
import './home.scss'
import Bander from '../../static/images/banner.png'
import Saoma from '../../static/images/saoma.png'
import Dianti from '../../static/images/dianti.png'
import Caiji from '../../static/images/caiji.png'
import Baoyang from '../../static/images/baoyang.png'
import Tongji from '../../static/images/tongji.png'
import Jihua from '../../static/images/jihua.png'
import { getWechatConfig, wxValidationPermissions, getPermissions } from '../../api/Sys'
import { getMyLiftList, getAssignLiftList } from '../../api/MyLift'
import { getCalendar } from '../../api/MaintenanceCalendar'
import { getMyLiftList as getWaitSignList } from '../../api/ToBeSigned'
import { pageList as getContractPageList, getMe } from '../../api/ContractCollect'
import wx from 'weixin-js-sdk'
import { Toast } from 'antd-mobile';

// ===== 宫格按角色按需显示（2026-10-25 需求：有的人员就不让看）=====
// 管理/财务类角色（命中任一即视为"管理人员"，可看敏感菜单）
const MANAGER_ROLES = ['GLY', 'YHPTGLY', 'YYJL', 'CW', 'BGS-ZR', 'WY', 'WY-CK', 'KF', 'QYGLY', 'shichangbujingli', 'KF-APP'];
// 敏感菜单 url -> 可见角色要求（"manager"=仅管理角色；"share"=管理角色或经销商）
const SENSITIVE_URLS = {
  '/layout/salary': 'manager',           // 我的工资单
  '/layout/taskAssigned': 'manager',     // 任务指派(管)
  '/layout/contractCollect': 'manager',  // 合同催收
  '/layout/bossDashboard': 'manager',    // 老板看板
  '/layout/shareStatistics': 'share',    // 分成统计（经销商分成对经销商可见）
};
const loadUserRoleCodes = () => {
  try {
    const list = JSON.parse(localStorage.getItem('userRoleList') || '[]');
    return (Array.isArray(list) ? list : []).map(r => (r && (r.roleCode || r.role_code)) || '').filter(Boolean);
  } catch (e) { return []; }
};
// 是否管理角色
const isManager = (roleCodes) => roleCodes.some(c => MANAGER_ROLES.indexOf(c) >= 0);
// 敏感菜单是否对当前角色可见；无角色缓存时（老用户未重新登录）默认全部可见，避免误隐藏
const canSeeSensitive = (url) => {
  const roleCodes = loadUserRoleCodes();
  if (!roleCodes.length) return true;
  const rule = SENSITIVE_URLS[url];
  if (!rule) return true;
  if (rule === 'share') return isManager(roleCodes) || roleCodes.indexOf('JSX-WX') >= 0;
  return isManager(roleCodes);
};

const list = [
  {
    text: '扫码',
    url: '/layout/scanCode',
    fun: '',
    icon: Saoma,
    type: 'scanCode',
  },
  {
    text: '我的电梯',
    url: '/layout/mylift',
    fun: '',
    icon: Dianti,
    type: 'jump',
    badge: 'myLift'
  },
  {
    text: '采集',
    url: '/layout/collect',
    fun: '',
    icon: Caiji,
    type: 'jump'
  },
  {
    text: '保养',
    url: '/layout/maintenanceList',
    fun: '',
    icon: Baoyang,
    type: 'jump',
    badge: 'todayMaint'
  },
  {
    text: '统计',
    url: '/layout/statistical',
    fun: '',
    icon: Tongji,
    type: 'jump'
  },
  {
    text: '维保日历',
    url: '/layout/calendar',
    fun: '',
    icon: Jihua,
    type: 'jump',
    badge: 'tomorrowMaint'
  },
  {
    text: '我的任务',
    url: '/layout/myTask',
    fun: '',
    icon: Dianti,
    type: 'jump',
    badge: '',
    alwaysShow: true
  },
  {
    text: '任务指派',
    url: '/layout/mylift2',
    fun: '',
    icon: Dianti,
    type: 'jump',
    badge: 'assignTask'
  },
  {
    text: '技术文档',
    url: '/employeeslayout/documentList',
    fun: '',
    icon: Tongji,
    type: 'jump'
  },
  {
    text: '待签字',
    url: '/layout/toBeSigned',
    fun: '',
    icon: Tongji,
    type: 'jump',
    badge: 'toBeSigned'
  },
  {
    text: '分成统计',
    url: '/layout/shareStatistics',
    fun: '',
    icon: Tongji,
    type: 'jump'
  },
  {
    text: '我的工资单',
    url: '/layout/salary',
    fun: '',
    icon: Tongji,
    type: 'jump',
    alwaysShow: true
  },
  {
    text: '任务指派(管)',
    url: '/layout/taskAssigned',
    fun: '',
    icon: Tongji,
    type: 'jump',
    alwaysShow: true
  },
  {
    text: '合同催收',
    url: '/layout/contractCollect',
    fun: '',
    icon: Tongji,
    type: 'jump',
    alwaysShow: true,
    badge: 'contractCollect'
  },
  {
    text: '老板看板',
    url: '/layout/bossDashboard',
    fun: '',
    icon: Tongji,
    type: 'jump',
    alwaysShow: true
  }
];

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      badges: {}
    }
  }
  componentWillMount() {
    this.getPermissionsFun()
  }
  componentDidMount() {
    this.getWechatConfigFun()
    this.loadBadges()
  }
  // 首页功能角标：我的电梯/保养(今天)/维保日历(明天)/任务指派/待签字/合同催收
  fmtDate = d => {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return y + '-' + m + '-' + dd
  }
  loadBadges = async () => {
    const me = getMe()
    const today = this.fmtDate(new Date())
    const tomorrow = this.fmtDate(new Date(Date.now() + 86400000))
    const badges = { myLift: 0, todayMaint: 0, tomorrowMaint: 0, assignTask: 0, toBeSigned: 0, contractCollect: 0 }
    try {
      const [liftRes, calToday, calTomorrow, assignRes, signRes, contractRes] = await Promise.all([
        getMyLiftList({ pageIndex: 1, pageSize: 1 }),
        getCalendar({ statisticsDate: today }),
        getCalendar({ statisticsDate: tomorrow }),
        getAssignLiftList({ pageIndex: 1, pageSize: 1 }),
        getWaitSignList({ pageIndex: 1, pageSize: 1 }),
        me && me.userId ? getContractPageList({ pageIndex: 1, pageSize: 1, assignUserId: me.userId }) : Promise.resolve({ code: 999 }),
      ])
      badges.myLift = liftRes.code === 200 ? (liftRes.data && liftRes.data.total) || 0 : 0
      badges.todayMaint = calToday && calToday.code === 200 ? (calToday.data && calToday.data.planAmount) || 0 : 0
      badges.tomorrowMaint = calTomorrow && calTomorrow.code === 200 ? (calTomorrow.data && calTomorrow.data.planAmount) || 0 : 0
      badges.assignTask = assignRes.code === 200 ? (assignRes.data && assignRes.data.total) || 0 : 0
      badges.toBeSigned = signRes.code === 200 ? (signRes.data && signRes.data.total) || 0 : 0
      badges.contractCollect = contractRes.code === 200 ? (contractRes.data && contractRes.data.total) || 0 : 0
    } catch (e) {
      console.log('badges error', e)
    }
    this.setState({ badges })
  }
  // 判断是不是ios
  isIos = () => {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
  }
  // 获取授权
  getWechatConfigFun = async () => {
    let url = window.location.href.split("#")[0];
    if (this.isIos()) {
      url = localStorage.getItem('url')
    }
    const res = await getWechatConfig(url)
    if (res.code === 200) {
      const data = { ...res.data }
      data.jsApiList = ['scanQRCode', 'getLocation']
      wxValidationPermissions(data)
    }
  }
  getPermissionsFun = async () => {
    const res = await getPermissions()
    let arr = []
    if (res.code === 200) {
      res.data.forEach((item) => {
        if (item.attributes.menuShow) {
          arr.push(item.attributes.menuUrl)
        }
      })
      let showList = []
      list.forEach((item) => {
        // 敏感菜单按角色显示（分成统计/我的工资单/任务指派(管)/合同催收/老板看板）：
        // 普通维保/维修员工默认不显示；管理角色（老板/财务/签约人等）显示
        if (SENSITIVE_URLS[item.url] && !canSeeSensitive(item.url)) return
        if (item.alwaysShow || arr.indexOf(item.url) >= 0) {
          showList.push(item)
        }
      })
      this.setState({
        list: showList
      })
      console.log(showList)
    }
  }
  jump = (item) => {
    if (item.type === 'jump') {
      this.props.history.push(item.url)
    } else if (item.type === 'scanCode') {
      this.scanQRCode()
    }
    // this.props.history.push(item.url)
  }
  scanQRCode = () => {
    const that = this
    wx.ready(() => {
      wx.checkJsApi({
        jsApiList: ["scanQRCode"],
        success(res) {
          if (res.checkResult.scanQRCode === false) {
            const message =
              "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！";
            console.log(message);
          } else {
            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                const liftCode = result.split(':')[1]
                // if (num % 2 === 0) {
                //   that.props.history.push({ pathname: `/tourists/${liftCode}` });
                // } else {
                //   that.props.history.push({ pathname: `/employees/${liftCode}` });
                // }
                that.props.history.push({ pathname: `/employees/${liftCode}` });

              },

            });
          }
        },
        fail(res) {
          const message = "checkJsApi fail=" + JSON.stringify(res);
          Toast.fail(message, 3)
          console.log(message, "2222222");
        },
      });

    });
    wx.error(function (res) {
      console.log(res, 'res-----home')
    })

  }
  getLocation = () => {
    console.log('location')
    wx.ready(() => {
      console.log("初始化js-sdk成功");
      wx.checkJsApi({
        jsApiList: ["getLocation"],
        success(res) {
          if (res.checkResult.getLocation === false) {
            const message =
              "你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！";
            console.log(message);
          } else {
            const message = "js-sdk检查成功";
            wx.getLocation({
              type: "wgs84", // 默认为wgs84的 gps 坐标，如果要返回直接给 openLocation 用的火星坐标，可传入'gcj02'
              success: function (res) {
                console.log(res);
                var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                var speed = res.speed; // 速度，以米/每秒计
                var accuracy = res.accuracy; // 位置精度
              },
            });
          }
        },
        fail(res) {
          const message = "checkJsApi fail=" + JSON.stringify(res);
          console.log(message, "2222222");
        },
      });

    });
    wx.error(function (res) {
      console.log(res, '----')
    })
  };
  render() {
    const badges = this.state.badges || {}
    const nodes = this.state.list.map((item, index) => {
      const num = item.badge ? badges[item.badge] : 0
      return (
        <li key={index} onClick={() => this.jump(item)}>
          <img src={item.icon} alt="" />
          <span>{item.text}</span>
          {num > 0 ? <em className="home-badge">{num > 99 ? '99+' : num}</em> : null}
        </li>
      )
    })
    return (
      <div className="HomeBox">
        <div className="headerBox">
          <img src={Bander} alt="" onClick={this.getLocation} />
        </div>
        <div>
          <ul>
            {nodes}
            <li></li>
          </ul>
        </div>
      </div>
    )
  }
}


export default Home;
